import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { useHistory } from 'react-router-dom';
import { ActionStrip } from './ActionStrip';
export var FullScreenActionStrip = function FullScreenActionStrip(props) {
  var history = useHistory();
  var _props$mobileOverride = props.mobileOverrides,
      mobileOverrides = _props$mobileOverride === void 0 ? {} : _props$mobileOverride,
      onBack = props.onBack,
      preventDefault = props.preventDefault;

  var handleOnBack = function handleOnBack() {
    if (onBack) {
      onBack();
    }

    if (!preventDefault) {
      history.goBack();
    }
  };

  var mobileProps = _objectSpread(_objectSpread(_objectSpread({}, props), mobileOverrides), {}, {
    onBack: handleOnBack
  });

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ActionStrip, mobileProps));
};